import { useState, useCallback } from 'react';
import { ToastMessage } from '../components/Toast';

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((toast: Omit<ToastMessage, 'id'>) => {
    const id = Math.random().toString(36).substr(2, 9);
    const newToast: ToastMessage = {
      ...toast,
      id,
    };
    
    setToasts(prev => [...prev, newToast]);
    return id;
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  // Convenience methods
  const showError = useCallback((message: string, title?: string, duration?: number) => {
    return addToast({
      type: 'error',
      title,
      message,
      duration,
    });
  }, [addToast]);

  const showSuccess = useCallback((message: string, title?: string, duration?: number) => {
    return addToast({
      type: 'success',
      title,
      message,
      duration,
    });
  }, [addToast]);

  const showWarning = useCallback((message: string, title?: string, duration?: number) => {
    return addToast({
      type: 'warning',
      title,
      message,
      duration,
    });
  }, [addToast]);

  const showInfo = useCallback((message: string, title?: string, duration?: number) => {
    return addToast({
      type: 'info',
      title,
      message,
      duration,
    });
  }, [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    clearAllToasts,
    showError,
    showSuccess,
    showWarning,
    showInfo,
  };
};